import { Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import RecipeTable from "../../ProductionChart/components/RecipeTable";

export const Recipes = (props) => {
  const { selectedOptionRecipe, globalData } = props;
  const recipeRef = useRef(null);

  useEffect(() => {
    if (recipeRef.current) {
      recipeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedOptionRecipe]);

  return (
    <Box ref={recipeRef}>
      {selectedOptionRecipe && (
        <RecipeTable recipe={selectedOptionRecipe} globalData={globalData} />
      )}
    </Box>
  );
};
